export default "__VITE_ASSET__fyeHV23d__"